//#region Libraries
import { useNavigate } from "react-router";
//#endregion
//#region Styles
import { FooterFormManualLoading } from "components/styles";
//#endregion
//#region Components
import DialogAlertAction from "components/DialogAlertAction/DialogAlertAction";
import CustomButton from "components/CustomButton/CustomButton";
import DialogAlertSuccessNotify from "components/DialogAlertNotify/DialogAlertSuccessNotify/DialogAlertSuccessNotify";
import DialogAlertErrorSimple from "components/DialogAlertErrorSimple/DialogAlertErrorSimple";
//#endregion
//#region Reducer
import { TYPES } from "../../utils/reducer/acadReinforce.actions";
//#endregion
//#region Services
import {
	requestCreateAcadReinforce,
	requestFinalizeAcadReinforceDraft,
	requestUpdateAcadReinforceById,
} from "services/acadReinforce/aboutAcadReinforce";
import { acadReinforcementSessionStorage } from "services/storage/acadReinforcement";
//#endregion
//#region Utils
import ABSOLUTE_PATHS from "routes/utils/absolutePaths";
import validator from "../../utils/validations";
import { useNavigatingAway } from "utils/hooks/usePrompt";
import useMainContext from "utils/context/useMainContext";
import useShowDialogAlert from "components/DialogAlert/utils/hooks/useDialogAlert";
import { ACAD_REINFORCE_CONSTANTS } from "config/constants";
import { INITIAL_STATE } from "../../utils/reducer/acadReinforce.reducer";
import { wait } from "utils/others";
//#endregion

const Footer = ({
	loadingRequest,
	fillAcadReinforceResumeData,
	currentStep,
	createAcadReinforce,
	setChangingStep,
	stepsQuantity,
	nextStep,
	toStep,
	form,
	errors,
	changeErrorsStep,
	setMustCorrect,
	setHiddenToastMessageSaveAcadReinforceAsDraft,
	changeErrorText,
	canShowDialogLeavingPage,
	setCanShowDialogLeavingPage,
}) => {
	//#region Extra
	const navigate = useNavigate();
	const mainContext = useMainContext();
	//#region Manejo de salida de vista
	const [showDialogLeavingPage, confirmNavigation, cancelNavigation] =
		useNavigatingAway(canShowDialogLeavingPage);
	//#endregion
	//#endregion
	//#region Dialogs
	const dialogShowCancelAcadReinforce = useShowDialogAlert();
	const dialogShowCreatedAcadReinforce = useShowDialogAlert(
		(toggle, value) => {
			toggle();
			if (value === false) toAcadReinforceList();
		}
	);
	const dialogShowUpdatedAcadReinforce = useShowDialogAlert(
		(toggle, value) => {
			toggle();
			if (value === false) toAcadReinforceList();
		}
	);
	const dialogShowError = useShowDialogAlert();
	//#endregion
	//#region Functions
	const showSuccessToastMessageSaveAcadReinforceAsDraft = async () => {
		setHiddenToastMessageSaveAcadReinforceAsDraft(false);
		await wait(2400);
		setHiddenToastMessageSaveAcadReinforceAsDraft(true);
	};
	//#region Errors Checkers
	const checkErrorDueTeacherAccountIsNotLicensedStep1 = (
		newErrors,
		message
	) => {
		if (
			message !==
			ACAD_REINFORCE_CONSTANTS.FORM_ERRORS.TUTOR_ACCOUNT_IS_NOT_LICENSED
		)
			return false;
		newErrors.part2.tutor = true;
		changeErrorText(
			"tutorSearch",
			"El tutor no puede crear links privados si no tiene una cuenta de zoom con licencia"
		);
		changeErrorsStep(TYPES.SET_FORM_ERRORS_STEP_1, newErrors);
		return true;
	};
	const checkErrorDueTeacherAccountIsNotLicensedStep2 = (
		newErrors,
		message
	) => {
		if (
			message !==
			ACAD_REINFORCE_CONSTANTS.FORM_ERRORS.TUTOR_ACCOUNT_IS_NOT_LICENSED
		)
			return false;
		newErrors.part3.locationId = true;
		changeErrorText(
			"location",
			"El tutor no puede crear links privados si no tiene una cuenta de zoom con licencia"
		);
		changeErrorsStep(TYPES.SET_FORM_ERRORS_STEP_2, newErrors);
		return true;
	};
	const checkErrorDueTutorEmailNotExistsStep1 = (newErrors, message) => {
		if (
			message !==
			ACAD_REINFORCE_CONSTANTS.FORM_ERRORS.TUTOR_EMAIL_NOT_EXISTS
		)
			return false;
		newErrors.part2.tutor = true;
		changeErrorText("tutorSearch", "El tutor no tiene correo asociado");
		changeErrorsStep(TYPES.SET_FORM_ERRORS_STEP_1, newErrors);
		return true;
	};
	const checkErrorDueTutorEmailNotExistsStep2 = (newErrors, message) => {
		if (
			message !==
			ACAD_REINFORCE_CONSTANTS.FORM_ERRORS.TUTOR_EMAIL_NOT_EXISTS
		)
			return false;
		newErrors.part3.locationId = true;
		changeErrorText(
			"location",
			"Zoom no está permitido para este tutor porque no cuenta con un email asociado"
		);
		changeErrorsStep(TYPES.SET_FORM_ERRORS_STEP_2, newErrors);
		return true;
	};
	const checkErrorDueIsRequiredALicensedAccountToUpdateTheMeetingHost = (
		newErrors,
		message
	) => {
		if (
			message !==
			ACAD_REINFORCE_CONSTANTS.FORM_ERRORS
				.UPDATE_HOST_NOT_LICENSED_ACCOUNT
		)
			return false;
		newErrors.part2.tutor = true;
		changeErrorText(
			"tutorSearch",
			"Se necesita un tutor con una cuenta con licencia para actualizar el anfitrión de la reunión"
		);
		changeErrorsStep(TYPES.SET_FORM_ERRORS_STEP_1, newErrors);
		return true;
	};
	const checkErrorDueLimitExceedMeeting = (newErrors, message) => {
		if (message !== ACAD_REINFORCE_CONSTANTS.FORM_ERRORS.LIMIT_EXCEEDED)
			return false;
		newErrors.part3.locationId = true;
		changeErrorText(
			"location",
			"El límite de reuniones creadas ha sido alcanzado."
		);
		changeErrorsStep(TYPES.SET_FORM_ERRORS_STEP_2, newErrors);
		return true;
	};
	const checkErrorDueExistsACrossSchedule = (newErrors, message) => {
		if (message !== ACAD_REINFORCE_CONSTANTS.FORM_ERRORS.CROSS_SCHEDULE)
			return false;
		newErrors.part2.duration.areInvalidTimes = true;
		changeErrorText(
			"invalidTimes",
			"El horario seleccionado genera cruces."
		);
		changeErrorsStep(TYPES.SET_FORM_ERRORS_STEP_2, newErrors);
		return true;
	};
	const checkErrorDueExistsPeopleSoftError = message => {
		if (message !== ACAD_REINFORCE_CONSTANTS.FORM_ERRORS.PS_ERROR)
			return false;
		mainContext.setDialogUnexpectedErrorMessage(
			"Ocurrió un error en peoplesoft"
		);
		mainContext.setShowDialogUnexpectedError(true);
		return true;
	};
	//#endregion
	const resetErrorTexts = () => {
		changeErrorText("tutorSearch", INITIAL_STATE.errorTexts.tutorSearch);
		changeErrorText("invalidTimes", INITIAL_STATE.errorTexts.invalidTimes);
		changeErrorText("location", INITIAL_STATE.errorTexts.location);
	};
	const saveAcadReinforceData = async loadingMessage => {
		const acadReinforceId =
			acadReinforcementSessionStorage.acadReinforceId.get();
		let isValid = null;
		resetErrorTexts();
		switch (currentStep) {
			case 1: {
				const result = validator.isValidFormStep1(form.step1, errors);
				changeErrorsStep(
					TYPES.SET_FORM_ERRORS_STEP_1,
					result.newErrors
				);
				isValid = result.isValid;
				if (!isValid) break;
				loadingRequest.show(loadingMessage);
				// Si es edición
				if (acadReinforceId) {
					const { success, message } =
						await requestUpdateAcadReinforceById(
							acadReinforceId,
							form.step1,
							"step1"
						);
					if (
						checkErrorDueTutorEmailNotExistsStep1(
							result.newErrors,
							message
						)
					) {
						isValid = false;
						break;
					}
					if (
						checkErrorDueTeacherAccountIsNotLicensedStep1(
							result.newErrors,
							message
						)
					) {
						isValid = false;
						break;
					}
					if (
						checkErrorDueIsRequiredALicensedAccountToUpdateTheMeetingHost(
							result.newErrors,
							message
						)
					) {
						isValid = false;
						break;
					}
					if (checkErrorDueExistsPeopleSoftError(message)) {
						isValid = false;
						break;
					}
					if (!success) isValid = null;
					break;
				}
				// Si es creación
				const { message, newAcadReinforceId } =
					await requestCreateAcadReinforce(form.step1);
				if (
					checkErrorDueTutorEmailNotExistsStep1(
						result.newErrors,
						message
					)
				)
					isValid = false;
				if (
					checkErrorDueTeacherAccountIsNotLicensedStep1(
						result.newErrors,
						message
					)
				)
					isValid = false;
				if (!isValid) break;
				if (newAcadReinforceId)
					acadReinforcementSessionStorage.acadReinforceId.set(
						newAcadReinforceId
					);
				else isValid = null;
				break;
			}
			case 2: {
				const result = validator.isValidFormStep2(form.step2);
				changeErrorsStep(
					TYPES.SET_FORM_ERRORS_STEP_2,
					result.newErrors
				);
				isValid = result.isValid;
				if (!isValid) break;
				loadingRequest.show(loadingMessage);
				const { success, message } =
					await requestUpdateAcadReinforceById(
						acadReinforceId,
						form.step2,
						"step2"
					);
				if (
					checkErrorDueTutorEmailNotExistsStep2(
						result.newErrors,
						message
					)
				) {
					isValid = false;
					break;
				}
				if (
					checkErrorDueTeacherAccountIsNotLicensedStep2(
						result.newErrors,
						message
					)
				) {
					isValid = false;
					break;
				}
				if (
					checkErrorDueLimitExceedMeeting(result.newErrors, message)
				) {
					isValid = false;
					break;
				}
				if (
					checkErrorDueExistsACrossSchedule(result.newErrors, message)
				) {
					isValid = false;
					break;
				}
				if (checkErrorDueExistsPeopleSoftError(message)) {
					isValid = false;
					break;
				}
				if (!success) isValid = null;
				break;
			}
			default:
				return false;
		}
		manageResultRequestSaveAcadReinforce(isValid);
		loadingRequest.hide();
		return isValid;
	};
	const manageResultRequestSaveAcadReinforce = isValid => {
		if (isValid === null) {
			mainContext.setShowDialogUnexpectedError(true);
			return;
		}
		if (!isValid) {
			setMustCorrect(true);
			setTimeout(() => {
				setMustCorrect(false);
			}, 2400);
		} else if (createAcadReinforce || isDraft) {
			setCanShowDialogLeavingPage(false);
		}
		window.scrollTo({ top: 0, behavior: "smooth" });
	};
	const saveAndContinue = async () => {
		const isValid = await saveAcadReinforceData("Guardando información...");
		if (!isValid) return;
		nextStep();
		fillAcadReinforceResumeData();
		setChangingStep(true);
		showSuccessToastMessageSaveAcadReinforceAsDraft();
	};
	const saveAcadReinforceAsDraft = async () => {
		const isValid = await saveAcadReinforceData("Guardando información...");
		if (!isValid) return;
		showSuccessToastMessageSaveAcadReinforceAsDraft();
	};
	const finalizeAcadReinforce = async () => {
		loadingRequest.show("Guardando tu refuerzo...");
		const message = await requestFinalizeAcadReinforceDraft(
			acadReinforcementSessionStorage.acadReinforceId.get()
		);
		loadingRequest.hide();
		if (!message) {
			// Exitoso
			window.scroll({ top: 0, behavior: "smooth" });
			nextStep();
			dialogShowCreatedAcadReinforce.toggle();
			return;
		}
		// Fallido
		switch (message) {
			case ACAD_REINFORCE_CONSTANTS.FORM_ERRORS.CROSS_SCHEDULE:
				mainContext.setDialogUnexpectedErrorMessage(
					"El horario seleccionado genera cruces, actualízalo por favor."
				);
				break;
			case ACAD_REINFORCE_CONSTANTS.FORM_ERRORS.ENVIRONMENT_NOT_AVAILABLE:
				dialogShowError.toggle();
				return;
			case ACAD_REINFORCE_CONSTANTS.FORM_ERRORS.UNEXPECTED_ERROR:
				break;
			default:
				break;
		}
		mainContext.setShowDialogUnexpectedError(true);
	};
	const updateAcadReinforceStep = async () => {
		const isValid = await saveAcadReinforceData(
			"Actualizando tu refuerzo..."
		);
		if (!isValid) return;
		// Es borrador
		if (acadReinforcementSessionStorage.isAcadReinforceDraft.get()) {
			toStep(3);
			setChangingStep(true);
			fillAcadReinforceResumeData();
			return;
		}
		dialogShowUpdatedAcadReinforce.toggle();
	};
	const navigateToAcadReinforce = () => {
		navigate(ABSOLUTE_PATHS.ACAD_REINFORCE_LIST);
	};
	const toAcadReinforceList = () => {
		setTimeout(() => {
			navigateToAcadReinforce();
			confirmNavigation();
		}, 380);
	};
	const cancelAcadReinforce = async () => {
		setCanShowDialogLeavingPage(false);
		dialogShowCancelAcadReinforce.toggle();
		navigateToAcadReinforce();
		confirmNavigation();
	};
	//#endregion
	const isDraft = acadReinforcementSessionStorage.isAcadReinforceDraft.get();
	return (
		<>
			<FooterFormManualLoading>
				<div>
					<CustomButton
						text="Cancelar"
						variant="sixtinary"
						onClick={() =>
							navigate(ABSOLUTE_PATHS.ACAD_REINFORCE_LIST)
						}
					/>
					{createAcadReinforce && currentStep < 3 && (
						<CustomButton
							variant="quintinary"
							text="Guardar Borrador"
							onClick={saveAcadReinforceAsDraft}
						/>
					)}
				</div>
				{currentStep >= stepsQuantity ? (
					isDraft || createAcadReinforce ? (
						<CustomButton
							text="Finalizar"
							onClick={finalizeAcadReinforce}
						/>
					) : (
						<CustomButton
							text="Cerrar"
							onClick={navigateToAcadReinforce}
						/>
					)
				) : createAcadReinforce ? (
					<CustomButton
						text="Guardar y continuar"
						onClick={saveAndContinue}
					/>
				) : (
					<CustomButton
						text="Actualizar"
						onClick={updateAcadReinforceStep}
					/>
				)}
			</FooterFormManualLoading>
			<DialogAlertAction
				show={dialogShowCancelAcadReinforce.value}
				toggleShow={dialogShowCancelAcadReinforce.toggle}
				title={`¿Deseas cancelar ${
					createAcadReinforce ? "la creación" : "el editado"
				} de tu refuerzo?`}
				content="Recuerda que esta información no se guardará y tendrás que empezar de nuevo."
			>
				<CustomButton
					variant="quintinary"
					text="Sí, salir"
					width="130px"
					onClick={cancelAcadReinforce}
				/>
				<CustomButton
					variant="quaternary"
					text="No, continuar"
					width="130px"
					onClick={() => dialogShowCancelAcadReinforce.toggle()}
				/>
			</DialogAlertAction>
			<DialogAlertAction
				show={showDialogLeavingPage}
				toggleShow={cancelNavigation}
				title="¿Deseas salir sin guardar tu refuerzo?"
				content="Recuerda que al salir, la información que has escrito recientemente, no se guardará"
			>
				<CustomButton
					variant="quintinary"
					text="Sí, salir"
					width="130px"
					onClick={confirmNavigation}
				/>
				<CustomButton
					variant="quaternary"
					text="No, continuar"
					width="130px"
					onClick={cancelNavigation}
				/>
			</DialogAlertAction>
			<DialogAlertSuccessNotify
				show={dialogShowCreatedAcadReinforce.value}
				toggleShow={dialogShowCreatedAcadReinforce.toggle}
				title="Hemos creado tu refuerzo"
				description="Lo podrás visualizar en el listado de refuerzos"
				buttons={
					<CustomButton
						variant="quaternary"
						text="Ir al listado de refuerzos"
						onClick={() => dialogShowCreatedAcadReinforce.toggle()}
					/>
				}
			/>
			<DialogAlertSuccessNotify
				show={dialogShowUpdatedAcadReinforce.value}
				toggleShow={dialogShowUpdatedAcadReinforce.toggle}
				title="Hemos actualizado tu refuerzo"
				description="Lo podrás visualizar en el listado de refuerzos"
				buttons={
					<CustomButton
						variant="quaternary"
						text="Ir al listado de refuerzos"
						onClick={() =>
							dialogShowUpdatedAcadReinforce.toggle(false)
						}
					/>
				}
			/>
			<DialogAlertErrorSimple
				dialogShow={dialogShowError}
				title="El ambiente ya no se encuentra disponible"
				content="Revisa el listado nuevamente y selecciona uno nuevo."
			/>
		</>
	);
};

export default Footer;
